
import axios from 'axios';
const { page_arguments } = window.tg;
import { showFormAlert } from '../general/form-ajax-alert';
const bsn = require('bootstrap.native');
let cancelToken;
export function favouritesUpdate(type = "edit") {
    let form = document.getElementById("edit_favourite_modal");
    let formData = new FormData(form);
    let formDataObj = {};
    for (let [key, value] of formData.entries()) {
        formDataObj[key] = value;
    }

    if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    let data = {
        ...formDataObj,
        hash: `${page_arguments.filter1}`,
        name: document.getElementById("js-select-name-favourites").value,
    };

    if (document.getElementById("js-collection-caption")) {
        data = {
            ...data,
            caption: document.getElementById("js-collection-caption").value,
        }
    }

    if (document.getElementById("private")) {
        data = {
            ...data,
            private: document.getElementById("private").checked,
        }
    }

    cancelToken = axios.CancelToken.source();
    let urlString = '/backend/favourites/'
    if (type === 'edit') {
        urlString += 'update';
    } else if (type === 'share') {
        data = {
            hash: `${page_arguments.filter1}`,
            name: document.getElementById("js-friend-name").value,
            email: document.getElementById("js-friend-email").value,
        };
        urlString += 'invite';
    } else {
        urlString += 'delete';
    }

    axios({
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
        url: urlString,
        cancelToken: cancelToken.token,
        data: data,
    })
        .then(function (response) {
            const output = response.data;
            showFormAlert(form.id, output.status, output.message);
            if (output.status == "SUCCESS") {
                setTimeout(() => {
                    if (type === 'share') {
                        document.querySelector('.js-shared-with-block').innerHTML += output.html;
                        document.querySelector('.js-add-friend-btn').style.display = "block";
                        document.querySelector('.js-add-friend-block').style.display = "none";
                        document.querySelector('.js-send-share-btn').style.display = "none";
                        document.getElementById("js-friend-name").value = "";
                        document.getElementById("js-friend-email").value = "";
                    } else if (type === 'delete') {
                        window.location = output.url;
                    } else {
                        window.Alpine.store('search').start = data.start;
                        window.Alpine.store('search').end = data.end;

                        const newPax = parseInt(data.pax);
                        const guestLabel = _p('kd.global.guest_plural', '%1$s Guest', '%1$s Guests', newPax)

                        window.Alpine.store('search').allocation.adult.value = newPax;
                        window.Alpine.store('search').allocation.child.value = 0;
                        window.Alpine.store('search').allocation.child_ages.value = [];
                        window.Alpine.store('search').total = newPax;
                        window.Alpine.store('search').total_label = guestLabel;
                        document.getElementById("expanded-search-pax").innerText = guestLabel

                        window.fetchResults();
                    }

                    var findModalInitJS = new bsn.default.Modal(document.getElementById('js-modal'));
                    findModalInitJS.hide();
                }, 2000);
            }
        })
        .catch(function (error) {
            if (axios.isCancel(error)) {
                console.log("Request canceled", error.message);
            }
            return false;
        });
}
